<style lang="scss" scoped>
.payment-package-image {
  max-width: 100%;
  margin: auto;
  display: block;
}

.payment-package-list {
  list-style-type: none;
}

.package-button {
  white-space: normal;
  padding: 30px;
}

.package-button.selected {
  box-shadow: 0 0 0 0.4rem $payment-selected-package-btn-shadow;
  background-color: lighten($primary, 10%);
  border-color: lighten($primary, 10%);
}

.btn-back {
  color: $white;
  background-color: $payment-back-btn-color;
  border-color: $payment-back-btn-border;
}
</style>

<template>
  <div class="p-md-5">
    <div class="pb-2 d-flex flex-wrap justify-content-around">
      <p class="text-center text-xl">Bezahlen mit {{ methods[name] }}</p>
    </div>
    <component :is="getComponent(name)"></component>
    <div class="row">
      <div class="col" v-for="(pack, index) in service.packages" :key="index">
        <div class="payment-package-list">
          <button
            :class="{ selected: packageIndex == index }"
            class="w-100 btn btn-primary text-xl mb-3 package-button"
            @click="selectPackage(index)"
          >
            <span class="text-nowrap">Paket {{ index + 1 }}:</span>
            <br />
            <span class="text-nowrap">{{ pack.amount }} {{ appCurrency }}</span>
            <br />
            <span class="text-nowrap"
              >für {{ formatCurrency(pack.price) }}</span
            >
            <br />
            <span><strong>Einmalig</strong>, kein ABO</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 order-md-2 mb-3">
        <button
          class="h-100 w-100 btn btn-success text-xl buy-button"
          @click="buy(service.packages[packageIndex])"
        >
          Kostenpflichtig {{ packageCoins }} {{ appCurrency }} für
          {{ packagePrice }} kaufen
          <div v-if="hasBonus" class="mt-2 font-weight-bold">
            BONUS: {{ bonus }} {{ appCurrency }} GRATIS dazu!
          </div>
        </button>
      </div>
      <div class="col-md-3 order-md-1 mb-3">
        <button
          @click="back"
          type="button"
          class="h-100 w-100 btn btn-back text-xl"
        >
          Zurück
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from "@/js/currency";
import InfoPaysafecard from "@/components/payment/info/InfoPaysafecard";
import InfoCall2pay from "@/components/payment/info/InfoCall2pay";
import InfoHandypay from "@/components/payment/info/InfoHandypay";

export default {
  components: {
    InfoPaysafecard,
    InfoCall2pay,
    InfoHandypay
  },
  props: {
    service: Object,
    name: String
  },
  data() {
    return {
      packageIndex: 0,
      bonus: null,
      methods: {
        paypal: "PayPal",
        creditcard: "Kreditkarte",
        "creditcard-micropayment": "Kreditkarte",
        klarna: "Klarna",
        prepaid: "Prepaid",
        paysafecard: "Paysafecard",
        call2pay: "Call2Pay",
        handypay: "Handypay"
      }
    };
  },
  computed: {
    hasBonus() {
      return this.bonus && this.bonus > 0;
    },
    appCurrency() {
      return Laravel.lang.currency;
    },
    packageCoins() {
      return this.service.packages[this.packageIndex].amount;
    },
    packagePrice() {
      return formatCurrency(this.service.packages[this.packageIndex].price);
    }
  },
  created() {
    this.selectPackage(0);
  },
  methods: {
    selectPackage(index) {
      this.packageIndex = index;
      this.setBonusFromCoins(this.service.packages[index].amount);
    },
    setBonusFromCoins(coins) {
      if (this.service.bonus) {
        this.$http
          .get("api/v1/payment/price-from-amount", {
            params: {
              type: "package",
              amount: coins
            }
          })
          .then(({ data }) => {
            this.bonus = data.bonus;
          });
      }
    },
    formatCurrency(price) {
      return formatCurrency(price);
    },
    back() {
      this.$emit("back");
    },
    buy({ amount, price }) {
      this.$emit("buy", { method: this.name, price: price, coins: amount });
    },
    getComponent(type) {
      return "Info" + type.charAt(0).toUpperCase() + type.slice(1);
    }
  }
};
</script>
